import React from "react";
import {
  Heart,
  Globe2,
  Calculator,
  GraduationCap,
  Scale,
  FileText,
  ArrowRight,
  Sparkles,
} from "lucide-react";
import { useLang } from "../LanguageContext";

const ICONS = [Heart, Globe2, Calculator, GraduationCap, Scale, FileText];
const ACCENTS = ["green", "navy", "orange", "purple", "red", "yellow"];

export const SimpleWords = () => {
  const { t } = useLang();
  return (
    <section id="simple" className="section bg-white">
      <div className="container-x">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow">
            <Sparkles size={12} /> {t("simple.eyebrow")}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl mt-5 text-[#002B7F] leading-[1.05]">
            {t("simple.headline1")}{" "}
            <span className="text-[#F37021]">{t("simple.headline2")}</span>
          </h2>
          <p className="mt-5 text-[#4A4A4A] text-base max-w-2xl mx-auto">
            {t("simple.subtext")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {[1, 2, 3, 4, 5, 6].map((n, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={n}
                className={`simple-card accent-${ACCENTS[i]}`}
                data-testid={`simple-card-${n}`}
              >
                <div className="simple-number">{n}</div>
                <div className="simple-icon">
                  <Icon size={22} />
                </div>
                <h3 className="simple-title">{t(`simple.${n}.title`)}</h3>
                <p className="simple-desc">{t(`simple.${n}.desc`)}</p>
              </article>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <a href="#contact" className="btn-orange" data-testid="simple-cta">
            {t("simple.cta")} <ArrowRight size={18} />
          </a>
          <div className="mt-4 text-[13px] text-[#4A4A4A] italic">
            {t("simple.cta.sub")}
          </div>
        </div>
      </div>
    </section>
  );
};
